import * as yup from "yup";

export interface FormData {
  companyName: string;
  cvrNumber: string;
  subject: string;
  totalEmployees: string;
  hasInsurance: string;
  name: string;
  phoneNumber: string;
  email: string;
}

yup.setLocale({
  mixed: {
    required: "Dette felt er obligatorisk",
  },
});

export const validationSchema = () => {
  return yup.object().shape({
    companyName: yup.string().required(),
    cvrNumber: yup.string().required(),
    subject: yup.string().required(),
    totalEmployees: yup.string().when("subject", {
      is: (value: string) => value === "Sundhedsforsikringer",
      then: () => yup.string().required(),
      otherwise: () => yup.string(),
    }),
    hasInsurance: yup.string().required(),
    name: yup.string().required(),
    phoneNumber: yup.string().required(),
    email: yup.string().required().email(`Dette er ikke en gyldig email`),
  });
};

export const to = (body: any) => {
  switch (body.subject) {
    case "Sundhedsforsikringer":
      return "sundhed-salg@gjensidige.dk";
    case "Erhvervsforsikringer":
      return "erhverv@gjensidige.dk";
    case "Landbrugsforsikringer":
      return "landbrug@gjensidige.dk";
  }
};

export default validationSchema;
